import * as Env from "./env";

const config: iConfig = Env;

export default config;
